const isLocalhost = process.env.BASE_URL?.includes('localhost:3000');

export function proxifyImageUrl(url: string): string {
    if (isLocalhost) {
        return url;
    }

    if (url.startsWith('http')) {
        return `/api/image-proxy?url=${encodeURIComponent(url)}`;
    }

    return url;
}

export function proxifyDictionaryImages(obj: any): any {
    if (isLocalhost) {
        return obj;
    }

    if (typeof obj === 'string' && obj.startsWith('http') && obj.includes('imagekit')) {
        return `/api/image-proxy?url=${encodeURIComponent(obj)}`;
    } else if (Array.isArray(obj)) {
        return obj.map(proxifyDictionaryImages);
    } else if (typeof obj === 'object' && obj !== null) {
        const copy: any = {};
        for (const key in obj) {
            copy[key] = proxifyDictionaryImages(obj[key]);
        }
        return copy;
    }

    return obj;
}
